import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { PnrInfo } from 'src/app/core/models/itinerary.model';
import { BreadcrumbRoute } from 'src/app/core/models/models';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-default-breadcumb',
  templateUrl: './default-breadcumb.component.html',
  styleUrls: ['./default-breadcumb.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DefaultBreadcumbComponent implements OnInit {
  breadcrumbs$: Observable<BreadcrumbRoute[]>;
  exceptionMode$: Observable<boolean>;
  showExceptionSwitch$: Observable<boolean>;
  actionActive$: Observable<string>;
  loading$: Observable<boolean>;
  loadingActions$: Observable<boolean>;
  loadingRules$: Observable<boolean>;
  pnrInfo$: Observable<PnrInfo>;

  constructor(
    public layoutService: LayoutService,
    private service: ItineraryService,
    private itinService: ItineraryService
  ) {}

  ngOnInit() {
    this.breadcrumbs$ = this.layoutService.getBreadcrumb();
    this.exceptionMode$ = this.layoutService.exceptionMode$;
    this.showExceptionSwitch$ = this.layoutService.getShowExceptionSwitch();
    this.actionActive$ = this.layoutService.getActionActive();
    this.loading$ = this.itinService.getLoading();
    this.loadingActions$ = this.layoutService.getLoadingActions();
    this.pnrInfo$ = this.service.getPnrInfo();
    this.loadingRules$ = this.itinService.getLoadingRules();
  }

  changeValue(exceptionMode: boolean) {
    this.layoutService.dispatchExceptionMode(exceptionMode);
  }
}
